<template>
  <!-- <m-card v-bind="$attrs" v-on="$listeners">
    <v-card tile flat height="500" text class="py-2">
      <v-chart auto-resize :options="options" />
    </v-card>
    <template v-slot:footer v-slot="loading">
      <m-elapsed :loading="loading"></m-elapsed>
    </template>
  </m-card>-->
  <v-card tile flat height="500" text class="py-2">
    <v-chart auto-resize :options="options" />
  </v-card>
</template>

<style>
.echarts {
  width: 100%;
  height: 100%;
}
</style>

<script>
import ECharts from "vue-echarts/components/ECharts";
import "echarts/lib/chart/bar";
// import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";

export default {
  inheritAttrs: false,
  components: {
    "v-chart": ECharts
  },
  props: {
    opLegend: {
      default: () => [
        "Organisasai 1",
        "Organisasai 2",
        "Organisasai 3",
        "Organisasai 4",
        "Organisasai 5"
      ]
    },
    opSeries: {
      default: () => [
        {
          name: "Organisasai 1",
          data: [150]
        },
        {
          name: "Organisasai 2",
          data: [80]
        },
        {
          name: "Organisasai 3",
          data: [100]
        },
        {
          name: "Organisasai 4",
          data: [210]
        },
        {
          name: "Organisasai 5",
          data: [60]
        }
      ]
    },
    opLabel: { default: "Data" }
  },
  data() {
    return {};
  },
  computed: {
    options() {
      return {
        grid: { containLabel: true },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          data: ["Dalam Proses", "Selesai"]
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "value",
          name: "Berkas",
          label: {
            show: true,
            position: "top"
          },
          axisLabel: {
            formatter: "{value}"
          }
        },
        yAxis: {
          type: "category",
          inverse: true,
          data: this.opLabel,
          label: {
            show: true
          }
        },

        series: this.opSeries
      };
    }
  },
  mounted() {},
  methods: {}
};
</script>